import { z } from 'zod';
import { russianPhoneSchema } from '../const/russianPhoneSchema';

export const signInPhoneSchema = z.object({
    provider: z.literal('phone'),
    data: z.object({
        phoneNumber: russianPhoneSchema,
    }),
});

export type SignInPhoneSchema = z.infer<typeof signInPhoneSchema>;

export const signInEmailSchema = z.object({
    provider: z.literal('email'),
    data: z.object({
        email: z
            .string()
            .trim()
            .toLowerCase()
            .min(1, { message: 'Это поле обязательно для заполнения' })
            .email('Неверный формат почты'),
    }),
});

export type SignInEmailSchema = z.infer<typeof signInEmailSchema>;

export const signInSchema = z.union([signInPhoneSchema, signInEmailSchema]);

export type SignInSchema = z.infer<typeof signInSchema>;
